export const legacyHashRegexp: RegExp = /^#(\d+)$/;
